

































































































































































































































import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
import { timeFormat } from "@/utils";

@Component({
  name: "system",
})
export default class CombinationProperty extends Vue {
  @Prop() result: any;
  @Prop() roleDetailsOptions: any;
  @Prop() ticketCategory: any;

  @Provide() private ruleForm: any = {
    id: "",
    planName: "",
    strategy: "",
    time: [],
    sequence: "",
    distinguish: "", //区分方式
    company: "", //运营商
    status: "",
  };
  @Provide() private readValue: string = "";
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;

  @Provide() private token: string | null = "";
  @Provide() private isSaved: any = false;
  @Provide() private msg: any = this.$message;
  @Provide() private newQuestion: any = {};
  @Provide() private timeSlotOptions: any = [
    { id: 0, name: "0:00" },
    { id: 1, name: "1:00" },
    { id: 2, name: "2:00" },
    { id: 3, name: "3:00" },
    { id: 4, name: "4:00" },
    { id: 5, name: "5:00" },
    { id: 6, name: "6:00" },
    { id: 7, name: "7:00" },
    { id: 8, name: "8:00" },
    { id: 9, name: "9:00" },
    { id: 10, name: "10:00" },
    { id: 11, name: "11:00" },
    { id: 12, name: "12:00" },
    { id: 13, name: "13:00" },
    { id: 14, name: "14:00" },
    { id: 15, name: "15:00" },
    { id: 16, name: "16:00" },
    { id: 17, name: "17:00" },
    { id: 18, name: "18:00" },
    { id: 19, name: "19:00" },
    { id: 20, name: "20:00" },
    { id: 21, name: "21:00" },
    { id: 22, name: "22:00" },
    { id: 23, name: "23:00" },
  ];
  @Provide() private companyOptions: any = [
    { id: 1, name: "airudder" },
    { id: 2, name: "wiz" },
    { id: 3, name: "nxtele" },
    { id: 4, name: "94AI" },
  ];
  @Provide() private details: any = []; //详情
  @Provide() private statusOptions: any = [
    { id: 1, name: "authority.Enable" },
    { id: 2, name: "authority.Disable" },
  ]; //详情

  @Provide() private detailsOptions: any = []; //详情
  @Provide() private distinguishOptions: any = [
    { id: 1, name: "formLgy.TicketCategory" },
    { id: 2, name: "authority.role" },
  ]; //区分方式
  // 开始时间限制
  public pickerOptions1: any = {
    disabledDate: (time: Date) => {
      if (this.ruleForm.time[1]) {
        return (
          time.getTime() > new Date(this.ruleForm.time[1]).getTime() ||
          time.getTime() <= new Date().getTime() - 86400000
        );
      }
      return time.getTime() <= new Date().getTime() - 86400000;
    },
  };
  private created() {
    this.token = localStorage.getItem("token");
    // this.ruleForm = this.result;
    this.details = this.result["details"].map(Number);
    this.ruleForm = this.result;
    if (this.result.distinguish === "1") {
      this.readValue = "1";
      this.ruleForm.distinguish = Number(this.readValue);
      this.detailsOptions = this.ticketCategory;
    } else if (this.result.distinguish === "2") {
      this.readValue = "2";
      this.ruleForm.distinguish = Number(this.readValue);
      this.detailsOptions = this.roleDetailsOptions;
    } else {
      this.ruleForm.distinguish = "";
    }
  }
  get rules() {
    if (
      this.ruleForm.planName != "" &&
      this.ruleForm.strategy != "" &&
      this.ruleForm.sequence != "" &&
      this.ruleForm.distinguish !== "" &&
      this.details.length > 0 &&
      this.ruleForm.time[0] &&
      this.ruleForm.time[1] &&
      this.ruleForm.company
    ) {
      this.isSaved = true;
      return true;
    }
    return false;
  }
  // 选择区分方式
  private selectRole(val: any) {
    this.detailsOptions = [];
    this.details = [];
    if (val === 1) {
      this.detailsOptions = this.ticketCategory;
    } else if (val === 2) {
      this.detailsOptions = this.roleDetailsOptions;
    }
  }
  private hideMsk() {
    this.hideContainer();
  }
  // 点击关闭弹窗
  private hideContainer() {
    this.$emit("returnRiskReport", {
      isShow: true,
    });
  }
  // 问题列表

  private submitForm() {
    let that = this;
    if (that.rules) {
      //  新建和编辑服务端非要用两个接口，咱也不敢说，咱也不敢问
      if (that.ruleForm.id === "") {
        that.saveAddRobot();
      } else {
        that.saveEditRobot();
      }
    } else {
      this.$message({
        type: "error",
        message: "pls check the form value!",
      });
      return false;
    }
  }

  private params() {
    let _arg: any = {
      id: this.ruleForm.id,
      // 计划名称
      planName: this.ruleForm.planName,
      // 策略名
      strategy: this.ruleForm.strategy,
      sequence: this.ruleForm.sequence,
      details: this.details.toString(),
      company: this.ruleForm.company,
      status: this.ruleForm.status,
    };

    _arg.itemids =
      this.ruleForm.distinguish === 1 ? this.details.toString() : ""; // 工单类型
    _arg.usergroupids =
      this.ruleForm.distinguish === 2 ? this.details.toString() : ""; // 角色ID
    if (
      this.ruleForm.time &&
      this.ruleForm.time.length > 0 &&
      this.ruleForm.time[0]
    ) {
      // 开始时间 - 结束时间
      _arg.timeRange =
        timeFormat(this.ruleForm.time[0]) +
        " - " +
        timeFormat(this.ruleForm.time[1]);
    }
    return _arg;
  }
  // 保存新建
  private async saveAddRobot() {
    const { addCallingPlanReq, addCallingPlanRequest }: any = await import(
      "@/request/robotManage"
    );
    let res = await addCallingPlanRequest.handleHttp(
      addCallingPlanReq(this.params()),
      this
    );
    if (res && res.right) {
      this.isSaved = false;
      this.$message({
        message: "success",
        type: "success",
      });
      this.closeAddDialog(false);
      this.$emit("updateList");
    } else {
      this.isSaved = false;
    }
  }
  // 保存编辑
  private async saveEditRobot() {
    const { editCallingPlanReq, editCallingPlanRequest }: any = await import(
      "@/request/robotManage"
    );
    let res = await editCallingPlanRequest.handleHttp(
      editCallingPlanReq(this.params()),
      this
    );
    if (res && res.right) {
      this.isSaved = false;
      this.$message({
        message: "success",
        type: "success",
      });
      this.closeAddDialog(false);
      this.$emit("updateList");
    } else {
      this.isSaved = false;
    }
  }

  // lee 关闭弹窗
  private closeAddDialog(bool: boolean) {
    this.$emit("returnRiskReport", {
      isShow: true,
    });
  }
}
